import { render, staticRenderFns } from "./Alarmsystems.vue?vue&type=template&id=33ec2f17&scoped=true&"
import script from "./Alarmsystems.vue?vue&type=script&lang=js&"
export * from "./Alarmsystems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ec2f17",
  null
  
)

export default component.exports